function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function insertText(textarea, text) {
  var _a, _b, _c;

  var before = textarea.value.slice(0, (_a = textarea.selectionStart) !== null && _a !== void 0 ? _a : undefined);
  var after = textarea.value.slice((_b = textarea.selectionEnd) !== null && _b !== void 0 ? _b : undefined);
  var canInsertText = true;
  textarea.contentEditable = 'true';

  try {
    canInsertText = document.execCommand('insertText', false, text);
  } catch (error) {
    canInsertText = false;
  }

  textarea.contentEditable = 'false';

  if (canInsertText && !textarea.value.slice(0, (_c = textarea.selectionStart) !== null && _c !== void 0 ? _c : undefined).endsWith(text)) {
    canInsertText = false;
  }

  if (!canInsertText) {
    try {
      document.execCommand('ms-beginUndoUnit');
    } catch (e) {}

    textarea.value = before + text + after;

    try {
      document.execCommand('ms-endUndoUnit');
    } catch (e) {}

    textarea.dispatchEvent(new CustomEvent('change', {
      bubbles: true,
      cancelable: true
    }));
  }
}

var skipFormattingMap = new WeakMap();

function setSkipFormattingFlag(event) {
  var el = event.currentTarget;
  var isSkipFormattingKeys = event.code === 'KeyV' && (event.ctrlKey || event.metaKey) && event.shiftKey;

  if (isSkipFormattingKeys || isSkipFormattingKeys && event.altKey) {
    skipFormattingMap.set(el, true);
  }
}

function unsetSkipFormattedFlag(event) {
  var el = event.currentTarget;
  skipFormattingMap.delete(el);
}

function shouldSkipFormatting(el) {
  var _a;

  var shouldSkipFormattingState = (_a = skipFormattingMap.get(el)) !== null && _a !== void 0 ? _a : false;
  return shouldSkipFormattingState;
}

function installAround(el, installCallbacks, optionConfig) {
  el.addEventListener('keydown', setSkipFormattingFlag);

  var _iterator = _createForOfIteratorHelper(installCallbacks),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var installCallback = _step.value;
      installCallback(el, optionConfig);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  el.addEventListener('paste', unsetSkipFormattedFlag);
}

function uninstall$5(el) {
  el.removeEventListener('keydown', setSkipFormattingFlag);
  el.removeEventListener('paste', unsetSkipFormattedFlag);
}

function install$4(el) {
  el.addEventListener('paste', onPaste$4);
}

function uninstall$4(el) {
  el.removeEventListener('paste', onPaste$4);
}

function onPaste$4(event) {
  var transfer = event.clipboardData;
  var el = event.currentTarget;
  if (shouldSkipFormatting(el)) return;
  if (!transfer || !hasHTML(transfer)) return;
  var field = event.currentTarget;
  if (!(field instanceof HTMLTextAreaElement)) return;

  if (isWithinUserMention(field)) {
    return;
  }

  var plaintext = transfer.getData('text/plain');
  var textHTML = transfer.getData('text/html');
  var textHTMLClean = textHTML.replace(/\u00A0/g, ' ').replace(/\uC2A0/g, ' ');
  if (!textHTML) return;
  plaintext = plaintext.trim();
  if (!plaintext) return;
  var parser = new DOMParser();
  var doc = parser.parseFromString(textHTMLClean, 'text/html');
  var walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_ELEMENT, function (node) {
    return node.parentNode && isLink(node.parentNode) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
  });
  var markdown = convertToMarkdown(plaintext, walker);
  if (markdown === plaintext) return;
  event.stopPropagation();
  event.preventDefault();
  insertText(field, markdown);
}

function convertToMarkdown(plaintext, walker) {
  var _a;

  var currentNode = walker.firstChild();
  var markdown = plaintext;
  var markdownIgnoreBeforeIndex = 0;
  var index = 0;
  var NODE_LIMIT = 10000;

  while (currentNode && index < NODE_LIMIT) {
    index++;
    var text = isLink(currentNode) ? (currentNode.textContent || '').replace(/[\t\n\r ]+/g, ' ') : ((_a = currentNode.firstChild) === null || _a === void 0 ? void 0 : _a.wholeText) || '';

    if (isEmptyString(text)) {
      currentNode = walker.nextNode();
      continue;
    }

    var markdownFoundIndex = markdown.indexOf(text, markdownIgnoreBeforeIndex);

    if (markdownFoundIndex >= 0) {
      if (isLink(currentNode)) {
        var markdownLink = linkify$2(currentNode, text);
        markdown = markdown.slice(0, markdownFoundIndex) + markdownLink + markdown.slice(markdownFoundIndex + text.length);
        markdownIgnoreBeforeIndex = markdownFoundIndex + markdownLink.length;
      } else {
        markdownIgnoreBeforeIndex = markdownFoundIndex + text.length;
      }
    }

    currentNode = walker.nextNode();
  }

  return index === NODE_LIMIT ? plaintext : markdown;
}

function isWithinUserMention(textarea) {
  var selectionStart = textarea.selectionStart || 0;

  if (selectionStart === 0) {
    return false;
  }

  var previousChar = textarea.value.substring(selectionStart - 1, selectionStart);
  return previousChar === '@';
}

function isEmptyString(text) {
  return !text || (text === null || text === void 0 ? void 0 : text.trim().length) === 0;
}

function isLink(node) {
  var _a;

  return ((_a = node.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'a' && node.hasAttribute('href');
}

function hasHTML(transfer) {
  return transfer.types.includes('text/html');
}

function linkify$2(element, label) {
  var url = element.href || '';
  var markdown = '';

  if (isUserMention(element)) {
    markdown = label;
  } else if (isSpecialLink(element) || areEqualLinks(url, label)) {
    markdown = url;
  } else {
    markdown = "[".concat(label, "](").concat(url, ")");
  }

  return markdown;
}

function isSpecialLink(link) {
  return link.className.indexOf('commit-link') >= 0 || !!link.getAttribute('data-hovercard-type') && link.getAttribute('data-hovercard-type') !== 'user';
}

function areEqualLinks(link1, link2) {
  link1 = link1.slice(-1) === '/' ? link1.slice(0, -1) : link1;
  link2 = link2.slice(-1) === '/' ? link2.slice(0, -1) : link2;
  return link1.toLowerCase() === link2.toLowerCase();
}

function isUserMention(link) {
  var _a;

  return ((_a = link.textContent) === null || _a === void 0 ? void 0 : _a.slice(0, 1)) === '@' && link.getAttribute('data-hovercard-type') === 'user';
}

function install$3(el) {
  el.addEventListener('dragover', onDragover$1);
  el.addEventListener('drop', onDrop$1);
  el.addEventListener('paste', onPaste$3);
}

function uninstall$3(el) {
  el.removeEventListener('dragover', onDragover$1);
  el.removeEventListener('drop', onDrop$1);
  el.removeEventListener('paste', onPaste$3);
}

function onDrop$1(event) {
  var transfer = event.dataTransfer;
  if (!transfer) return;
  if (hasFile$1(transfer)) return;
  if (!hasLink(transfer)) return;
  var links = extractLinks(transfer);
  if (!links.some(isImageLink)) return;
  event.stopPropagation();
  event.preventDefault();
  var field = event.currentTarget;
  if (!(field instanceof HTMLTextAreaElement)) return;
  insertText(field, links.map(linkify$1).join(''));
}

function onDragover$1(event) {
  var transfer = event.dataTransfer;
  if (transfer) transfer.dropEffect = 'link';
}

function onPaste$3(event) {
  var el = event.currentTarget;
  if (shouldSkipFormatting(el)) return;
  var transfer = event.clipboardData;
  if (!transfer || !hasLink(transfer)) return;
  var links = extractLinks(transfer);
  if (!links.some(isImageLink)) return;
  event.stopPropagation();
  event.preventDefault();
  var field = event.currentTarget;
  if (!(field instanceof HTMLTextAreaElement)) return;
  insertText(field, links.map(linkify$1).join(''));
}

function linkify$1(link) {
  return isImageLink(link) ? "\n![](".concat(link, ")\n") : link;
}

function hasFile$1(transfer) {
  return Array.from(transfer.types).indexOf('Files') >= 0;
}

function hasLink(transfer) {
  return Array.from(transfer.types).indexOf('text/uri-list') >= 0;
}

function extractLinks(transfer) {
  return (transfer.getData('text/uri-list') || '').split('\r\n');
}

var IMAGE_RE = /\.(gif|png|jpe?g)$/i;

function isImageLink(url) {
  return IMAGE_RE.test(url);
}

var pasteLinkAsPlainTextOverSelectedTextMap = new WeakMap();

function install$2(el, optionConfig) {
  var _a;

  pasteLinkAsPlainTextOverSelectedTextMap.set(el, ((_a = optionConfig === null || optionConfig === void 0 ? void 0 : optionConfig.defaultPlainTextPaste) === null || _a === void 0 ? void 0 : _a.urlLinks) === true);
  el.addEventListener('paste', onPaste$2);
}

function uninstall$2(el) {
  el.removeEventListener('paste', onPaste$2);
}

function onPaste$2(event) {
  var _a;

  var el = event.currentTarget;
  var element = el;
  var shouldPasteAsPlainText = (_a = pasteLinkAsPlainTextOverSelectedTextMap.get(element)) !== null && _a !== void 0 ? _a : false;
  var shouldSkipDefaultBehavior = shouldSkipFormatting(element);

  if (!shouldPasteAsPlainText && shouldSkipDefaultBehavior || shouldPasteAsPlainText && !shouldSkipDefaultBehavior) {
    return;
  }

  var transfer = event.clipboardData;
  if (!transfer || !hasPlainText(transfer)) return;
  var field = event.currentTarget;
  if (!(field instanceof HTMLTextAreaElement)) return;
  var text = transfer.getData('text/plain');
  if (!text) return;
  if (!isURL(text)) return;
  if (isWithinLink(field)) return;
  var selectedText = field.value.substring(field.selectionStart, field.selectionEnd);
  if (!selectedText.length) return;
  if (isURL(selectedText.trim())) return;
  event.stopPropagation();
  event.preventDefault();
  insertText(field, linkify(selectedText, text.trim()));
}

function hasPlainText(transfer) {
  return Array.from(transfer.types).includes('text/plain');
}

function isWithinLink(textarea) {
  var selectionStart = textarea.selectionStart || 0;

  if (selectionStart > 1) {
    var previousChars = textarea.value.substring(selectionStart - 2, selectionStart);
    return previousChars === '](';
  } else {
    return false;
  }
}

function linkify(selectedText, text) {
  return "[".concat(selectedText, "](").concat(text, ")");
}

function isURL(url) {
  try {
    var parsedURL = new URL(url);
    return removeTrailingSlash(parsedURL.href).trim() === removeTrailingSlash(url).trim();
  } catch (_a) {
    return false;
  }
}

function removeTrailingSlash(url) {
  return url.endsWith('/') ? url.slice(0, url.length - 1) : url;
}

function install$1(el) {
  el.addEventListener('dragover', onDragover);
  el.addEventListener('drop', onDrop);
  el.addEventListener('paste', onPaste$1);
}

function uninstall$1(el) {
  el.removeEventListener('dragover', onDragover);
  el.removeEventListener('drop', onDrop);
  el.removeEventListener('paste', onPaste$1);
}

function onDrop(event) {
  var transfer = event.dataTransfer;
  if (!transfer) return;
  if (hasFile(transfer)) return;
  var textToPaste = generateText(transfer);
  if (!textToPaste) return;
  event.stopPropagation();
  event.preventDefault();
  var field = event.currentTarget;

  if (field instanceof HTMLTextAreaElement) {
    insertText(field, textToPaste);
  }
}

function onDragover(event) {
  var transfer = event.dataTransfer;
  if (transfer) transfer.dropEffect = 'copy';
}

function onPaste$1(event) {
  var el = event.currentTarget;
  if (shouldSkipFormatting(el)) return;
  if (!event.clipboardData) return;
  var textToPaste = generateText(event.clipboardData);
  if (!textToPaste) return;
  event.stopPropagation();
  event.preventDefault();
  var field = event.currentTarget;

  if (field instanceof HTMLTextAreaElement) {
    insertText(field, textToPaste);
  }
}

function hasFile(transfer) {
  return Array.from(transfer.types).indexOf('Files') >= 0;
}

function columnText(column) {
  var noBreakSpace = "\xA0";
  var text = (column.textContent || '').trim().replace(/\|/g, '\\|').replace(/\n/g, ' ');
  return text || noBreakSpace;
}

function tableHeaders(row) {
  return Array.from(row.querySelectorAll('td, th')).map(columnText);
}

function tableMarkdown(node) {
  var rows = Array.from(node.querySelectorAll('tr'));
  var firstRow = rows.shift();
  if (!firstRow) return '';
  var headers = tableHeaders(firstRow);
  var spacers = headers.map(function () {
    return '--';
  });
  var header = "".concat(headers.join(' | '), "\n").concat(spacers.join(' | '), "\n");
  var body = rows.map(function (row) {
    return Array.from(row.querySelectorAll('td')).map(columnText).join(' | ');
  }).join('\n');
  return "\n".concat(header).concat(body, "\n\n");
}

function generateText(transfer) {
  if (Array.from(transfer.types).indexOf('text/html') === -1) return;
  var html = transfer.getData('text/html');
  if (!/<table/i.test(html)) return;
  var parser = new DOMParser();
  var parsedDocument = parser.parseFromString(html, 'text/html');
  var table = parsedDocument.querySelector('table');
  table = !table || table.closest('[data-paste-markdown-skip]') ? null : table;
  if (!table) return;
  var formattedTable = tableMarkdown(table);
  return html.replace(/<meta.*?>/, '').replace(/<table[.\S\s]*<\/table>/, "\n".concat(formattedTable));
}

function install(el) {
  el.addEventListener('paste', onPaste);
}

function uninstall(el) {
  el.removeEventListener('paste', onPaste);
}

function onPaste(event) {
  var el = event.currentTarget;
  if (shouldSkipFormatting(el)) return;
  var transfer = event.clipboardData;
  if (!transfer || !hasMarkdown(transfer)) return;
  var field = event.currentTarget;
  if (!(field instanceof HTMLTextAreaElement)) return;
  var text = transfer.getData('text/x-gfm');
  if (!text) return;
  event.stopPropagation();
  event.preventDefault();
  insertText(field, text);
}

function hasMarkdown(transfer) {
  return Array.from(transfer.types).indexOf('text/x-gfm') >= 0;
}

function subscribe(el, optionConfig) {
  installAround(el, [install$1, install$3, install$2, install, install$4], optionConfig);
  return {
    unsubscribe: function unsubscribe() {
      uninstall$5(el);
      uninstall$1(el);
      uninstall$4(el);
      uninstall$3(el);
      uninstall$2(el);
      uninstall(el);
    }
  };
}

export { install$4 as installHTML, install$3 as installImageLink, install$2 as installLink, install$1 as installTable, install as installText, subscribe, uninstall$4 as uninstallHTML, uninstall$3 as uninstallImageLink, uninstall$2 as uninstallLink, uninstall$1 as uninstallTable, uninstall as uninstallText };